import './search-input.scss';

/**
 * version    1.2
 * class      SearchInput
 * classdesc  Gestione input di ricerca riutilizzabile (modal + main)
 */
export class SearchInput {
  constructor() {
    // Trova tutti i form .a70search-form
    const forms = document.querySelectorAll('.a70search-form');

    if (!forms.length) {
      return;
    }

    forms.forEach((form) => {
      const input = form.querySelector('.search-form__input');

      // Submit: sia la variante mobile che quella desktop.
      // Vanno gestite entrambe e non solo quella visibile: l’invio con ENTER
      // fa click sul PRIMO submit del form (anche se nascosto da CSS) e un
      // submit disabled blocca l’invio implicito da tastiera.
      const submitButtons = form.querySelectorAll('.a70search-form-button__submit');

      // Clear: sia la variante mobile che quella desktop
      const clearButtons = form.querySelectorAll('.a70search-form-button__clear');

      if (!input || !submitButtons.length) {
        return;
      }

      // Assegna gli eventi (click sulla X + input digitato)
      this.bindEvents({ input, submitButtons, clearButtons });

      // Imposta lo stato iniziale dei pulsanti submit (disattivi quando input è vuoto)
      this.toggleSubmitButton({ input, submitButtons });
    });
  }

  /**
   * Aggancia gli eventi agli elementi del singolo form
   */
  bindEvents({ input, submitButtons, clearButtons }) {
    // Click sulla X -> svuota input
    clearButtons.forEach((clearButton) => {
      clearButton.addEventListener('click', () => {
        this.clearInput({ input, submitButtons });
      });
    });

    // Digitazione nell’input -> abilita/disabilita i pulsanti submit
    input.addEventListener('input', () => {
      this.toggleSubmitButton({ input, submitButtons });
    });
  }

  /**
   * Svuota l’input e aggiorna lo stato dei pulsanti submit
   */
  clearInput(params) {
    const { input, submitButtons } = params;
    input.value = '';
    input.focus();
    this.toggleSubmitButton({ input, submitButtons });
  }

  /**
   * Abilita/disabilita i pulsanti submit
   */
  toggleSubmitButton(params) {
    const { input, submitButtons } = params;
    const hasText = input.value.trim().length > 0;
    submitButtons.forEach((button) => {
      // alias locale: airbnb vieta l’assegnazione diretta sul parametro (no-param-reassign)
      const submitButton = button;
      submitButton.disabled = !hasText;
    });
  }
}
